<template>
  <v-container fluid style="padding-top: 0; padding-bottom: 0;">
    <v-col cols="12" class="content-box px-8">
      <v-row class="align-center">
        <v-col cols="12" md="6" class="py-0 sub-title"
          >Mis pedidos pendientes de facturación</v-col
        >
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            label="Buscar"
            class="custom-text-input"
            variant="underlined"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-col cols="12" sm="12" md="12" class="px-0 py-0 mt-4 rounded-small">
        <v-data-table
          :headers="pendingOrderHeaders"
          :items="pendingInvoiceOrders"
          :loading="loadingPendingOrders"
          :search="search"
          :items-per-page="5"
          hide-default-footer
        >
          <template v-slot:[`item.total_amount`]="{ item }">
            <div>{{ priceFormatter(item.total_amount) }}</div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn
                class="table-btn mr-2"
                @click="() => handlerDetailAction(item)"
                style="background-color: #2196F3"
              >
                <v-icon size="large" class="mr-1">mdi-eye</v-icon>
                VER DETALLE
              </v-btn>
              <v-btn
                class="table-btn mr-2"
                @click="() => handlerInvoiceAction(item)"
                style="background-color: #343EC4"
                :loading="loadingInvoice === item.id"
              >
                <v-icon size="large" class="mr-1">mdi-download</v-icon>
                FACTURAR
              </v-btn>
              <v-btn
                class="table-btn mr-2"
                @click="() => handlerEmailAction()"
                style="background-color: #6400D2"
              >
                <v-icon size="large" class="mr-1">mdi-email</v-icon>
                ENVIAR
              </v-btn>
              <v-btn
                class="table-btn"
                @click="() => handlerDeleteAction(item)"
                style="background-color: #D32F2F"
              >
                <v-icon size="large" class="mr-1">mdi-delete</v-icon>
                BORRAR
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <v-col cols="12" v-if="paginationPendingData.lastPage > 1">
          <div class="text-center">
            <v-pagination
              color="#343EC4"
              v-model="pagePendingInvoice"
              :length="paginationPendingData.lastPage"
              circle
            ></v-pagination>
          </div>
        </v-col>
      </v-col>
    </v-col>

    <v-col cols="12" class="content-box px-8 mt-4">
      <v-row class="align-center">
        <v-col cols="12" md="6" class="py-0 sub-title"
          >Mis pedidos facturados</v-col
        >
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            label="Buscar"
            class="custom-text-input"
            variant="underlined"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-col cols="12" sm="12" md="12" class="px-0 py-0 mt-4 rounded-small">
        <v-data-table
          :headers="invoicedOrdersHeader"
          :loading="loadingBilledOrders"
          :items="billedOrders"
          :search="search"
          :items-per-page="5"
          hide-default-footer
        >
          <template v-slot:[`item.invoice.bill_start_date_cae`]="{ item }">
            <div>
              {{
                item.invoice
                  ? moment(item.invoice.bill_start_date_cae).format(
                      "YYYY-MM-DD HH:MM:SS"
                    )
                  : null
              }}
            </div>
          </template>
          <template v-slot:[`item.total_amount`]="{ item }">
            <div>{{ priceFormatter(item.total_amount) }}</div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div class="d-flex justify-center">
              <span class="custom-badge" :style="renderBadge(item.status)">{{
                statusMap[item.status]
              }}</span>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn
                class="table-btn mr-2"
                @click="() => openUploadVoucherModal(item)"
                style="background-color:green"
                v-if="item.status === `pending_b2b`"
              >
                <v-icon size="large" class="mr-1">mdi-upload</v-icon>
                Subir comprobante
              </v-btn>
              <v-btn
                class="table-btn mr-2"
                @click="() => handlerDetailAction(item)"
                style="background-color: #2196F3"
              >
                <v-icon size="large" class="mr-1">mdi-eye</v-icon>
                VER DETALLE
              </v-btn>
              <v-btn
                class="table-btn mr-2"
                style="background-color: #343EC4"
                :loading="loadingDownload === item.id"
                @click="() => dowloadInvoice(item)"
              >
                <v-icon size="large" class="mr-1">mdi-download</v-icon>
                FACTURA PDF
              </v-btn>
              <v-btn
                class="table-btn mr-2"
                @click="() => handlerEmailAction()"
                style="background-color: #6400D2"
              >
                <v-icon size="large" class="mr-1">mdi-email</v-icon>
                ENVIAR
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <v-col cols="12" v-if="paginationBilledData.lastPage > 1">
          <div class="text-center">
            <v-pagination
              color="#343EC4"
              v-model="pageBilled"
              :length="paginationBilledData.lastPage"
              circle
            ></v-pagination>
          </div>
        </v-col>
      </v-col>
    </v-col>
    <simpleModal
      :active="openEmail"
      :closeModal="closeModal"
      :cancelBtn="false"
      :actionBtn="false"
      title="Envío de e-mail"
      text="Hemos enviado un correo electrónico a la dirección asociada a tu cuenta con un archivo PDF adjunto que detalla todos los aspectos de tu pedido"
    />
    <simpleModal
      :active="openDelete"
      :action="cancelOrder"
      :closeModal="closeModal"
      title="¿Estás seguro?"
      text="Al cancelar, todos los productos en la orden de compra serán eliminados."
    />
    <simpleModal
      :active="openDetails"
      :closeModal="closeModal"
      :cancelBtn="false"
      :actionBtn="false"
      modalSize="large"
      :title="`Detalle del pedido - ${selectedOrder && selectedOrder.id}`"
    >
      <v-data-table
        :headers="detailsHeader"
        :items="!!selectedOrder ? selectedOrder.items : []"
        :search="search"
        :items-per-page="5"
        :page.sync="page"
        :hide-default-footer="true"
        @page-count="pageCount = $event"
        class="my-6"
      >
        <template v-slot:[`item.subtotal`]="{ item }">
          <div>{{ priceFormatter(item.subtotal) }}</div>
        </template>
        <template v-slot:[`item.price_with_discount_no_iva`]="{ item }">
          <div>{{ priceFormatter(item.price_with_discount_no_iva) }}</div>
        </template>
      </v-data-table>
      <div class="d-flex flex-row justify-end  mt-3">
        <div class="sub-title2">Total (IVA incluido):</div>
        <div class="sub-title3 ml-4">
          {{ !!selectedOrder ? priceFormatter(selectedOrder.total_amount) : 0 }}
        </div>
      </div>
      <div class="d-flex flex-row justify-end  mt-4 " style="gap: 15px">
        <v-btn
          class="table-btn"
          style="background-color: #D32F2F"
          v-if="showBillingButton"
          @click="closeModal"
        >
          CANCELAR
        </v-btn>
        <v-btn
          class="table-btn"
          style="background-color: #343EC4"
          v-if="showBillingButton"
          @click="handlerEmitInvoice"
          :loading="loadingEmitInvoice"
        >
          CONFIRMAR
        </v-btn>
      </div>
    </simpleModal>
    <simpleModal
      :active="openInvoice"
      :closeModal="closeModal"
      :cancelBtn="false"
      :actionBtn="false"
      modalSize="large"
      :title="`Detalle del pedido - ${selectedOrder && selectedOrder.id}`"
    >
      <div>
        <div
          class="text-modal mt-3"
          v-if="!inventoryValidation.order_stock_can_be_fulfilled"
        >
          Lamentablemente, algunos de los productos de tu pedido no están
          disponibles en este momento.
        </div>
        <v-data-table
          :headers="invoicesHeader"
          :items="inventoryValidation.products"
          :search="search"
          :items-per-page="5"
          :page.sync="page"
          @page-count="pageCount = $event"
          :hide-default-footer="true"
          class="my-6"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex justify-center" v-if="item.to_be_assigned > 0">
              <v-btn
                class="table-btn"
                style="background-color: #D32F2F"
                @click="() => deleteItemFromOrder(item)"
              >
                BORRAR
              </v-btn>
            </div>
            <div class="d-flex justify-center" v-else>
              NO DISPONIBLE
            </div>
          </template>

          <template v-slot:[`item.to_be_assigned`]="{ item }">
            <span
              :style="
                !item.sufficient_stock && `font-weight: 700; color: #D32F2F`
              "
              >{{ item.to_be_assigned }}</span
            >
          </template>
        </v-data-table>
        <div class="d-flex flex-row justify-end  mt-1">
          <v-btn
            class="table-btn"
            style="background-color: #343EC4"
            @click="handlerUpdateOrder"
            :loading="loadingUpdateOrder"
          >
            ACTUALIZAR PEDIDO
          </v-btn>
        </div>
      </div>
    </simpleModal>
    <simpleModal
      :active="openPay"
      :closeModal="closeModal"
      :cancelBtn="false"
      :actionBtn="false"
      title="¡Listo! Solo un paso más"
    >
      <div>
        <div class="text-modal mt-3">
          Por favor, sube tu comprobante de pago para que podamos procesar tu
          pedido.
        </div>
        <div class="text-modal mt-2 mb-1" style="font-weight: 600;">
          Agregar comprobante
        </div>

        <v-row>
          <v-col cols="12" sm="7" md="7">
            <div
              class="drop-box"
              @drop.prevent="onDrop($event)"
              @dragover.prevent="dragover = true"
              @dragenter.prevent="dragover = true"
              @dragleave.prevent="dragover = false"
            >
              <v-icon color="#2196F3">
                mdi-file-upload-outline
              </v-icon>
              <div class="row-content">
                <button @click.prevent="openFilePicker" class="btn-link">
                  Click para cargar
                </button>
                <h6 class="text-drop">o arrastrar y soltar</h6>
              </div>
              <h6 class="text-drop color-light">
                PNG, JPG o PDF (max. 5MB)
              </h6>
            </div>
            <div style="display: none;">
              <v-file-input
                ref="fileInput"
                hidden
                multiple
                @change="onFileChange"
              ></v-file-input>
            </div>
          </v-col>
          <v-col cols="12" sm="5" md="5" class="pl-0">
            <div v-for="(file, index) in files" :key="index" class="file-box">
              <button
                class="close-icon"
                @click.prevent="() => deleteFile(file)"
              >
                <v-icon>
                  mdi-close
                </v-icon>
              </button>
              <h6 class="text-drop padding-right">{{ file.name }}</h6>
              <div class="text-size">
                <h6 class="text-drop color-light">
                  {{ (file.size / 1024).toFixed(2) }}kb
                </h6>
              </div>
              <v-progress-linear
                value="100"
                color="#2196F3"
                rounded
                height="6"
              ></v-progress-linear>
            </div>
          </v-col>
        </v-row>

        <div class="d-flex flex-row justify-end  mt-1">
          <v-btn
            class="table-btn"
            style="background-color: #343EC4"
            @click="handlerUploadVoucher"
            :loading="laodingPayment"
          >
            CARGAR
          </v-btn>
        </div>
      </div>
    </simpleModal>
    <simpleModal
      :active="openThanks"
      :action="closeModal"
      :closeModal="closeModal"
      :cancelBtn="false"
      title="¡Gracias por tu compra!"
      text="Por favor, ten en cuenta que tu pedido será procesado una vez que hayamos verificado tu comprobante de pago. Te mantendremos informado sobre el estado de tu pedido."
    />
  </v-container>
</template>

<script>
import simpleModal from "../modals/simpleModal.vue";
import { priceFormatter } from "../../../utils/formatters/priceFormatter";
import { downloadFile } from "../../../utils/helpers/dowloadFile";
import moment from "moment";

export default {
  components: {
    simpleModal,
  },
  data() {
    return {
      search: "",
      page: 1,
      pagePendingInvoice: 1,
      pageBilled: 1,
      itemsPerPage: 5,
      dragover: false,
      files: [],
      openEmail: false,
      openDelete: false,
      openDetails: false,
      showBillingButton: false,
      openInvoice: false,
      openThanks: false,
      openPay: false,
      loadingPendingOrders: false,
      loadingBilledOrders: false,
      loadingInvoice: null,
      loadingUpdateOrder: false,
      loadingCancel: null,
      laodingPayment: false,
      loadingDownload: false,
      loadingEmitInvoice: false,
      selectedOrder: null,
      deletedItemArr: [],
      pendingOrderHeaders: [
        {
          text: "Número de pedido",
          sortable: true,
          value: "id",
          align: "left",
        },
        {
          text: "Fecha de emisión",
          sortable: false,
          value: "created_at",
          align: "center",
        },
        {
          text: "Fecha de vencimiento",
          sortable: false,
          value: "due_date",
          align: "center",
        },
        {
          text: "Subtotal",
          sortable: false,
          value: "total_amount",
          align: "center",
        },
        {
          text: "Acciones",
          sortable: false,
          value: "actions",
          class: "action-column",
        },
      ],
      invoicedOrdersHeader: [
        {
          text: "Número de factura",
          sortable: true,
          value: "invoice.bill_number",
          align: "left",
        },
        {
          text: "Fecha de factura",
          sortable: false,
          value: "invoice.bill_start_date_cae",
          align: "center",
        },
        {
          text: "Total",
          sortable: false,
          value: "total_amount",
          align: "center",
        },
        {
          text: "Estado",
          sortable: false,
          value: "status",
          align: "center",
        },
        {
          text: "Acciones",
          sortable: false,
          value: "actions",
          class: "action-column",
        },
      ],
      detailsHeader: [
        {
          text: "Código",
          sortable: false,
          value: "sku",
          align: "left",
        },
        {
          text: "Cantidad",
          sortable: false,
          value: "quantity",
          align: "center",
        },
        {
          text: "Descripción",
          sortable: false,
          value: "title",
          align: "center",
        },
        {
          text: "Precio unitario neto",
          sortable: false,
          value: "price_with_discount_no_iva",
          align: "center",
        },
        {
          text: "IVA%",
          sortable: false,
          value: "iva",
          align: "center",
        },
        {
          text: "Subtotal",
          sortable: false,
          value: "subtotal",
          align: "center",
        },
      ],
      invoicesHeader: [
        {
          text: "Código",
          sortable: false,
          value: "sku",
          align: "left",
        },
        {
          text: "Descripción",
          sortable: false,
          value: "description",
          align: "center",
        },
        {
          text: "Cantidad pedida",
          sortable: false,
          value: "requested",
          align: "center",
        },
        {
          text: "Cantidad asignada",
          sortable: false,
          value: "to_be_assigned",
          align: "center",
        },
        {
          text: "Acciones",
          sortable: false,
          value: "actions",
          align: "center",
        },
      ],

      statusMap: {
        pending_b2b: "Confirmando el pago",
        paid: "En preparación",
        cancelled: "Rechazada",
      },
      detailsItems: [],
    };
  },

  mounted() {
    this.getPendingInvoiceOrders();
    this.getBilledOrders();
  },

  watch: {
    pagePendingInvoice(val) {
      this.getPendingInvoiceOrders(val);
    },
    pageBilled(val) {
      this.getBilledOrders(val);
    },
  },

  computed: {
    pendingInvoiceOrders() {
      return this.$store.getters["shoppingCart/PENDING_INVOICE_ORDERS"];
    },

    billedOrders() {
      return this.$store.getters["shoppingCart/BILLED_ORDERS"];
    },

    inventoryValidation() {
      return this.$store.getters["shoppingCart/GET_INVENTORY_VALIDATION"];
    },

    paginationBilledData() {
      return this.$store.getters["shoppingCart/GET_PAGINATION_BILLED_ORDERS"];
    },

    paginationPendingData() {
      return this.$store.getters["shoppingCart/GET_PAGINATION_PENDING_ORDERS"];
    },
  },

  methods: {
    moment,
    dowloadInvoice(item) {
      this.loadingDownload = item.id;
      downloadFile(
        `${process.env.VUE_APP_STORE}/api/orders/invoice_download?file=` +
          item.invoice.invoice_path_label,
        () => {
          this.loadingDownload = null;
        }
      );
    },
    renderBadge(status) {
      switch (true) {
        case status.toLowerCase() == "pending_b2b":
          return { color: "black", backgroundColor: "rgba(0, 0, 0, 0.08" };
        case status.toLowerCase() == "en preparación":
          return { color: "white", backgroundColor: "#2196F3" };
        case status.toLowerCase() == "listo para retirar":
          return { color: "white", backgroundColor: "#343EC4" };
        case status.toLowerCase() == "listo para envío":
          return { color: "white", backgroundColor: "#6400D2" };
        case status.toLowerCase() == "cancelled":
          return { color: "white", backgroundColor: "red" };
        default:
          return { color: "white", backgroundColor: "#262B70" };
      }
    },
    priceFormatter,
    async getPendingInvoiceOrders(page = 1) {
      this.loadingPendingOrders = true;
      const request = {
        page: page,
        per_page: this.itemsPerPage,
      };
      await this.$store.dispatch(
        "shoppingCart/GET_PENDING_INVOICE_ORDERS",
        request
      );
      this.loadingPendingOrders = false;
    },
    async getBilledOrders(page = 1) {
      this.loadingBilledOrders = true;
      const request = {
        page: page,
        per_page: this.itemsPerPage,
      };
      await this.$store.dispatch("shoppingCart/GET_INVOICED_ORDERES", request);
      this.loadingBilledOrders = false;
    },
    handlerDetailAction(item) {
      this.selectedOrder = item;
      this.openDetails = true;
    },
    handlerEmailAction() {
      this.openEmail = true;
    },
    handlerDeleteAction(item) {
      this.selectedOrder = item;
      this.openDelete = true;
    },
    async cancelOrder() {
      await this.$store.dispatch(
        "shoppingCart/CANCEL_ORDER",
        this.selectedOrder.id
      );
      this.closeModal();
      this.getPendingInvoiceOrders();
    },
    async handlerInvoiceAction(item) {
      this.selectedOrder = item;
      this.loadingInvoice = item.id;
      const response = await this.$store.dispatch(
        "shoppingCart/GET_INVENTORY_VALIDATION",
        item.id
      );
      this.loadingInvoice = null;
      const { order_stock_can_be_fulfilled } = response;
      if (order_stock_can_be_fulfilled) {
        this.openDetails = true;
        this.showBillingButton = true;
      } else {
        this.openInvoice = true;
      }
    },
    async handlerUpdateOrder() {
      this.loadingUpdateOrder = true;
      await this.$store.dispatch("shoppingCart/UPDATE_ORDER", {
        orderId: this.selectedOrder.id,
        payload: {
          items_to_delete: this.deletedItemArr,
        },
      });
      await this.getPendingInvoiceOrders();
      try {
        const order = await this.$store.dispatch(
          "shoppingCart/GET_ORDER_BY_ID",
          this.selectedOrder.id
        );
        this.selectedOrder = order;
        this.loadingUpdateOrder = false;

        this.openDetails = true;
        this.showBillingButton = true;
      } catch (error) {
        this.closeModal();
      }
    },
    async handlerEmitInvoice() {
      this.loadingEmitInvoice = true;
      try {
        await this.$store.dispatch(
          "shoppingCart/BILL_ORDER",
          this.selectedOrder.id
        );
        await Promise.all([
          this.getPendingInvoiceOrders(),
          this.getBilledOrders(),
        ]);
        this.closeModal();
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.loadingEmitInvoice = false;
      }
      // this.openPay = true;
    },
    async openUploadVoucherModal(item) {
      this.selectedOrder = item;
      this.openPay = true;
    },
    async handlerUploadVoucher() {
      this.laodingPayment = true;
      const receipt = this.files[0];
      if (!receipt) {
        this.$snotify.error("Debe subir un archivo", "Error");
        this.laodingPayment = false;
      }
      const payload = {
        receipt: this.files[0],
        order_id: this.selectedOrder.id,
      };
      await this.$store.dispatch("shoppingCart/UPLOAD_VOUCHER", payload);

      await Promise.all([
        this.getPendingInvoiceOrders(),
        this.getBilledOrders(),
      ]);
      this.laodingPayment = false;
      this.closeModal();
      this.openThanks = true;
    },
    closeModal() {
      this.showBillingButton = false;
      this.deletedItemArr = [];
      this.openEmail = false;
      this.openDelete = false;
      this.openDetails = false;
      this.openInvoice = false;
      this.openThanks = false;
      this.openPay = false;
    },

    openFilePicker() {
      this.$refs.fileInput.$refs.input.click();
    },
    onFileChange(item) {
      if (item[0]) {
        item.forEach((element) => {
          if (element.size < 3145728) {
            this.files.push(element);
          }
        });
      }
    },
    onDrop(item) {
      item.dataTransfer.files.forEach((element) => {
        if (element.size < 3145728) {
          this.files.push(element);
        }
      });
    },
    deleteFile(item) {
      const index = this.files.findIndex((el) => el.name === item.name);
      this.files.splice(index, 1);
    },

    deleteItemFromOrder({ order_item_id }) {
      this.deletedItemArr.push(order_item_id);
      this.$store.dispatch(
        "shoppingCart/REMOVE_ITEM_FROM_ORDER",
        order_item_id
      );
    },
  },
};
</script>

<style>
.content-box {
  background-color: white;
  border-radius: 10px;
}
.sub-title {
  font-size: 24px;
  font-weight: 500;
  color: black;
  line-height: 26px;
}
.sub-title2 {
  font-size: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  line-height: 24px;
}

.sub-title3 {
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  line-height: 24px;
}
.table-btn {
  height: 30px !important;
  font-size: 12px !important;
  color: white !important;
  padding: 0px 8px !important;
}
.action-column {
  width: 500px !important;
}
.v-data-table-header {
  background-color: #f5f5f5;
}
.v-data-table-header tr th span {
  font-size: 13px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}
.v-dialog .v-data-table-header {
  background-color: transparent;
}
.text-modal {
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  line-height: 20px;
}
.subtitle-label {
  padding: 0;
  margin: 0;
  color: #706dac;
  font-weight: 500 !important;
}
.drop-box {
  height: 150px;
  width: 100%;
  border: 2px dashed rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.text-drop {
  margin: 0px;
  font-weight: 500 !important;
  text-transform: none;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
}
.padding-right {
  padding-right: 14px;
}
.color-light {
  color: rgba(0, 0, 0, 0.6);
}
.row-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin: 10px 0 10px 0;
  align-items: center;
}
.btn-link {
  color: #2196f3;
  text-decoration: underline;
  margin-right: 6px;
  font-size: 15px;
}
.file-box {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 6px;
  margin-bottom: 5px;
}
.close-icon {
  position: absolute;
  right: 0;
  top: 1px;
  background-color: white;
}
.text-size {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 4px 0;
}
.custom-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 12px;
  border-radius: 100px;
  width: max-content;
}
</style>
